<template>
  <card>
    <div class="block">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in items"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          color="green"
          :size="activity.size"
        >
          <div class="timeline-card">
            <!-- HEADER -->
            <div
              :class="[
                'header-row',
                { 'header-row--expanded': activity.showNoteInput }
              ]"
              @click="toggleNoteInput(activity)"
            >
              <span class="status-label">{{ activity.statusTypeName }}</span>
              <div class="header-right">
                <span class="info-date">{{ activity.statusDateStr }}</span>
                <el-button
                  type="text"
                  circle
                  @click.stop="toggleNoteInput(activity)"
                  class="toggle-btn"
                >
                  <i :class="activity.showNoteInput ? 'el-icon-minus' : 'el-icon-plus'"></i>
                </el-button>
              </div>
            </div>

            <!-- CONTENT -->
            <div class="card-content">
              <!-- 1) Info + note-input -->
              <div v-show="activity.showNoteInput">
                <div v-if="!activity.claimId" class="info-section">
                  <div class="info-row">
                    <span class="info-label">{{ $t(activity.dispClaimNumber ? 'İş_nömrəsi' : 'Hadisə_nömrəsi') }}</span>
                    <span class="info-value">{{ activity.dispClaimNumber || activity.dispAccidentNumber }}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">{{ $t('Sığortalı') }}</span>
                    <span class="info-value">{{ formatValue(activity.insuredName) }}</span>
                  </div>
                  <div v-if="activity.policyType === 1" class="info-row">
                    <span class="info-label">{{ $t('DQN') }}</span>
                    <span class="info-value">{{ formatValue(activity.regNumber) }}</span>
                  </div>
                </div>

                <div v-else class="info-section two-column">
                  <div class="info-row">
                    <span class="info-label">{{ $t(activity.dispClaimNumber ? 'İş_nömrəsi' : 'Hadisə_nömrəsi') }}</span>
                    <span class="info-value" style="margin-left: 10px;">{{ activity.dispClaimNumber || activity.dispAccidentNumber }}</span>
                  </div>
                  <div class="info-columns">
                    <div class="info-column left-col">
                      <div v-if="activity.policyType === 1">
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Zərərvuran') }}</span>
                          <span class="info-value">
                            {{ formatValue(activity.insPersonName || activity.insPartPersonName) }}
                          </span>
                        </div>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('DQN') }}</span>
                          <span class="info-value">{{ formatValue(activity.insRegNumber) }}</span>
                        </div>
                      </div>
                      <div v-else>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Zərərvuran') }}</span>
                          <span class="info-value">
                            {{ formatValue(
                              activity.insPersonName ||
                              activity.insPartPersonName ||
                              activity.insOtherPropertyName ||
                              activity.insPolicyNumber
                            ) }}
                          </span>
                        </div>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Predmet') }}</span>
                          <span class="info-value">
                            {{ formatValue(activity.insOtherPropertyName || activity.insPolicyNumber) }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="info-column right-col">
                      <div v-if="activity.policyType === 1">
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Zərər_çəkən') }}</span>
                          <span class="info-value">
                            {{ formatValue(activity.osPersonName || activity.osPartPersonName) }}
                          </span>
                        </div>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('DQN') }}</span>
                          <span class="info-value">{{ formatValue(activity.osRegNumber) }}</span>
                        </div>
                      </div>
                      <div v-else>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Zərərçəkən') }}</span>
                          <span class="info-value">
                            {{ formatValue(
                              activity.osPersonName ||
                              activity.osPartPersonName ||
                              activity.osOtherPropertyName ||
                              activity.osPolicyNumber
                            ) }}
                          </span>
                        </div>
                        <div class="info-pair">
                          <span class="info-label">{{ $t('Predmet') }}</span>
                          <span class="info-value">
                            {{ formatValue(activity.osOtherPropertyName || activity.osPolicyNumber) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <el-divider></el-divider>
                <div class="note-input-section">
                  <el-input
                    v-model="activity.note"
                    :placeholder="$t('Qeyd_edin')"
                    size="small"
                    clearable
                  />
                  <el-button
                    size="small"
                    type="primary"
                    @click="saveNote(activity)"
                    :loading="activity.isSaving"
                  >
                    {{ $t('Yadda_saxla') }}
                  </el-button>
                </div>
              </div>

              <!-- 2) Existing Notes -->
              <div
                v-if="activity.notes && activity.notes.length"
                class="notes-section"
              >
                <div class="notes-header">{{ $t('Qeydlər') }}</div>
                <div
                  v-for="(note, noteIndex) in activity.notes"
                  :key="noteIndex"
                  class="note-item"
                >
                  <div class="note-text">{{ note.note }}</div>
                  <div class="note-meta">
        
                    <span class="note-user">{{ note.createUserName }}</span>
                    <span class="note-date">{{ note.createDateStr }}</span>
                  </div>
                  <div
                    class="note-actions"
                    :style="{ visibility: note.commandUserId === uid ? 'visible' : 'hidden' }"
                  >
                    <el-switch
                      v-model="note.status"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      size="mini"
                      @change="handleStatusChange(note, activity)"
                    />
                    <el-button type="text" @click="deleteNote(note, activity)">
                      <i class="fa-solid fa-trash-can" :title="$t('Ləğv_et')"></i>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </card>
</template>
<script>
import {
  GetAccidentsStatus,
  GetAccidentsStatusNote,
  CreateAccidentStatusNote,
  DeleteAccidentStatusNote,
  AccidentStatusNoteUpdate,
} from "../../services/common";

export default {
  props: {
    id: Number,
    type: String,
  },
  data() {
    return {
      items: [],
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    formatValue(value) {
      return value && value.trim() ? value : "Qeyd olunmayıb";
    },
    getData() {
      const isAccident = this.type === "accident";
      const accidentId = isAccident ? this.id : 0;
      const claimId = isAccident ? 0 : this.id;
      GetAccidentsStatus(accidentId, claimId)
        .then((response) => {
          if (response.data.data) {
            const sorted = response.data.data.sort(
              (a, b) => new Date(a.statusDate) - new Date(b.statusDate)
            );
            this.items = sorted.map((item) => ({
              ...item,
              note: "",
              isSaving: false,
              notes: [],
              showNoteInput: false, // reset here
            }));
            this.items.forEach((i) => this.getNotes(i));
          } else {
            this.$message.error("No data found!");
          }
        })
        .catch(() => {
          this.$message.error("Data retrieval error!");
        });
    },
    getNotes(activity) {
      GetAccidentsStatusNote(activity.statusId)
        .then((res) => {
          if (res.data) activity.notes = res.data.data.map((n) => ({ ...n }));
        })
        .catch(() => {
          this.$message.error("Qeyd alınmadı!");
        });
    },
    saveNote(activity) {
      if (!activity.note) {
        this.$message.warning("Qeyd yoxdur");
        return;
      }
      activity.isSaving = true;
      const params = {
        Id: 0,
        StatusId: activity.statusId,
        AccidentId: activity.accidentId,
        ClaimId: activity.claimId,
        Status: 1,
        Stage: activity.stage || 0,
        Note: activity.note,
        StatusTypeId: activity.statusTypeId,
        StatusTypeName: activity.statusTypeName,
        CommandUserId: this.uid
      };
      CreateAccidentStatusNote(params)
        .then(() => {
          this.$message.success("Uğurlu əməliyyat!");
          this.getNotes(activity);
          this.$emit("noteStatusUpdated");
          activity.note = "";
        })
        .catch(() => {
          this.$message.error("Səhv əməliyyat!");
        })
        .finally(() => {
          activity.isSaving = false;
        });
    },
    toggleNoteInput(activity) {
      activity.showNoteInput = !activity.showNoteInput;
    },
    handleStatusChange(note, activity) {
      note.uid = this.uid;
      AccidentStatusNoteUpdate(note)
        .then(() => {
          this.$message.success(
          `Qeyd ${note.status === 1 ? "Aktiv" : "Deaktiv"} edildi!`
          );
          this.$emit("noteStatusUpdated");
        })
        .catch(() => {
          this.$message.error("Səhv əməliyyat!");
        });
    },
    deleteNote(note, activity) {
      note.uid = this.uid;
      DeleteAccidentStatusNote(note)
        .then(() => {
          this.$message.success("Qeyd silindi!");
          activity.notes = activity.notes.filter((n) => n.id !== note.id);
          this.$emit("noteStatusUpdated");
        })
        .catch(() => {
          this.$message.error("Səhv əməliyyat!");
        });
    },
  },
  mounted() {
    this.getData();
  },
  activated() {
    // Eğer keep-alive ile cache’leniyorsa, her mount/activate’ta resetlesin
    this.items.forEach((i) => {
      i.showNoteInput = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.block {
  padding: 10px;
}
.timeline-card {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.header-row--expanded {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.status-label {
   font-size: var(--font-primary);
  font-weight: 600;
  color: #909399;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.info-date {
   font-size: var(--font-primary);
  color: #888;
}
.toggle-btn {
  padding: 0;
   font-size: var(--font-primary);
 color: var(--font-primary) !important;
  &:hover {
    color: #409EFF;
  }
  i {
      font-size: var(--font-medium);
    font-weight: bold;
  }
}
.card-content {
  font-size: var(--font-primary);
  color: #3d3c3a;
}
.info-row {
  display: flex;
  margin-bottom: 8px;
  align-items: baseline;
  line-height: 1;
}
.info-label {
  font-weight: 600;
  width: 100px;
  text-align: left;
  margin-right: 8px;
  flex-shrink: 0;
  font-size: var(--font-primary);
  color: #3A3A3A !important;
}
.info-value {
  margin-left: 20px;
  font-size: var(--font-primary);
  flex: 1;
  word-break: break-word;
}
.two-column {
  .info-columns {
    display: flex;
  }
  .info-column {
    flex: 1;
    min-width: 0;
    &.left-col {
      padding-right: 15px;
    }
    &.right-col {
      padding-left: 15px;
    }
  }
  .info-pair {
    display: flex;
    margin-bottom: 8px;
    .info-label {
      width: 90px;
    }
    .info-value {
      flex: 1;
    }
  }
}
.note-input-section {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  .el-input {
    flex: 1;
     font-size: var(--font-primary);
  }
  .el-button {
      font-size: var(--font-primary);
    padding: 8px 12px;
  }
}
.notes-section {
  margin-top: 16px;
}
.notes-header {
  font-weight: 600;
  margin-bottom: 8px;
   font-size: var(--font-primary);
  color: #555;
}
.note-item {
  background: #f9f9f9;
  padding: 10px 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  border-left: 3px solid #e0e0e0;
}
.note-text {
  margin-bottom: 4px;
  color: #333;
    font-size: var(--font-primary);
  line-height: 1.4;
}
.note-meta {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-primary);
  color: #888;
  .note-user {
    font-weight: 500;
  }
}
.note-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
  .el-button {
    padding: 0;
    height: auto;
    i {
      color: #808080;
        font-size: var(--font-medium);
    }
  }
}
.el-divider {
  margin: 12px 0;
  background-color: #e8e8e8;
}
.el-timeline {
  padding-left: 10px;
}
.el-timeline-item {
  padding-bottom: 12px;
  &:last-child {
    padding-bottom: 0;
  }
}
@media (max-width: 768px) {
  .info-label {
    width: 80px;
  }
  .two-column {
    .info-columns {
      flex-direction: column;
      gap: 10px;
    }
    .info-column {
      &.left-col {
        padding-right: 0;
        padding-bottom: 10px;
      }
      &.right-col {
        padding-left: 0;
        padding-top: 10px;
      }
    }
  }
}
</style>
